<template>
  <div class="company-box">
    <div
      class="company-item hvr-grow-bg"
      v-for="(item, index) in itemList"
      :key="index"
      :class="{
        [`bg${index + 1}`]: true,
      }"
    >
      <!-- 蒙版 -->
      <!-- <div class="company-mark-box"></div> -->
      <div class="company-content-box">
        <!-- <div class="company-icon">
          <img :src="item.icon" alt="" />
        </div> -->
        <div class="company-title">{{ item.title }}</div>
        <div class="company-text" v-for="text in item.text" :key="text">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      itemList: [
        {
          icon: require("@/assets/about/icon1.png"),
          title: "客户至上",
          text: ["以客户需求为核心，提供优质解决方案，", "助力客户成功。"],
        },
        {
          icon: require("@/assets/about/icon2.png"),
          title: "使命必达",
          text: ["坚守责任，执行，", "以专业精神确保目标高效实现。"],
        },
        {
          icon: require("@/assets/about/icon3.png"),
          title: "创新驱动",
          text: ["持续探索突破，", "以创新思维引领行业发展。"],
        },
        {
          icon: require("@/assets/about/icon4.png"),
          title: "协作共赢 ",
          text: ["团队同心，共享价值，", "与参与者共同创造辉煌。"],
        },
        {
          icon: require("@/assets/about/icon5.png"),
          title: "成长无限",
          text: ["自我主动学习，勇于挑战，", "不断超越，实现共同成长。"],
        },
        // {
        //   icon: require('@/assets/about/icon1.png'),
        //   title: '企业愿景',
        //   text: '行业领航者 ',
        // },
        // {
        //   icon: require('@/assets/about/icon2.png'),
        //   title: '核心文化',
        //   text: '自律 互动 高效 勇气',
        // },
        // {
        //   icon: require('@/assets/about/icon3.png'),
        //   title: '价值观',
        //   text: '卓越品质 一站式服务',
        // },
        // {
        //   icon: require('@/assets/about/icon4.png'),
        //   title: '团队建设',
        //   text: '源于自信 创新永无止境',
        // },
        // {
        //   icon: require('@/assets/about/icon5.png'),
        //   title: '工作理念',
        //   text: '立安思危 创优求存',
        // },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
